'use strict'

import $ from 'jquery'
import queryString from 'querystring'

export default class BlogFilter {
  constructor(el) {
    this.$el = $(el)
    this.$cards = this.$el.find('.card')
    this.$count = this.$el.find('.post-listing__count')
    this.$filterGroup = this.$el.find('.post-listing__filter-group')
    this.$filter = this.$el.find('.post-listing__filter')
    this.$topicFilter = this.$el.find('.post-listing__filter--topic')
    this.$grid = this.$el.find('.post-listing__grid')
    this.$loadMore = this.$el.find('.post-listing__load-more')
    this.query = queryString.parse(location.search)

    //Abort if no filtering mechanism
    if (!this.$filter.length) return false

    //State
    this.activeFilter = 'All'
    this.cardSets = {}
    this.setLength = 12
    this.setsLoaded = 1
    this.masterFilter = {}
    this.activeFilterSet = { author: [], topic: [], language: [] }

    //Init
    this.organizeTopicSets()
    this.bindEvents()
    this.checkQueryParams()
    this.handleCardLoading()

  }
  bindEvents() {
    this.$filter.find('li').on('click', (e) => {
      this.handleFilterUpdate($(e.currentTarget))
      this.handleCardLoading()
    })
    this.$filterGroup.find('p').on('click', (e) => {
      $(e.currentTarget).parent(this.$filterGroup).toggleClass('menu-open')
    })

    this.$loadMore.on('click', (e) => {

      this.setsLoaded++
      e.preventDefault()
      this.handleCardLoading()
    })
  }
  checkQueryParams() {
    if (Object.keys(this.query).length == 0) {
      this.updateQuery('topic', 'All', 'author', 'All', 'language', 'All')
    } else {
      for (let key in this.query) {
        const selectedTopic = this.query[key]
        let dataFilter = this.$filter.find($('[data-filter="' + selectedTopic + '"]'))
        if (selectedTopic != 'All') {
          this.handleFilterUpdate(dataFilter)
        }
      }
    }
  }
  handleFilterUpdate($filter) {
    const filterCategory = $filter.parent().data('category')
    const newTopic = $filter.data('filter')
    const newTopicAll = $filter.data('filter-name')
    const active = 'active'
    const targetFilter = $filter.parent('.post-listing__filter')

    if (!$filter.hasClass(active)) {
      if (newTopic === 'All') {
        this.activeFilterSet[filterCategory] = this.masterFilter[filterCategory]
        targetFilter.siblings('p').html(newTopicAll)
      } else {
        this.activeFilterSet[filterCategory] = []
        this.activeFilterSet[filterCategory].push(newTopic)
        targetFilter.siblings('p').html(newTopic)
      }
      this.updateQuery(filterCategory, newTopic)
      $filter.siblings().removeClass(active)
      $filter.addClass(active)
    }
    this.$filterGroup.removeClass('menu-open')
    this.setsLoaded = 1
  }
  filterCards() {
    const $filteredCards = []
    const { topic, author, language } = this.activeFilterSet
    this.$cards.each((i, card) => {
      const cardTopics = $(card).data('topic').split(',')
      let isTopicMatch = false
      for (let index = 0; index < topic.length; index++) {
        let topicString = topic[index]
        if (cardTopics.includes(topicString)) {
          isTopicMatch = true
        }
      }
      if (
        isTopicMatch &&
        author.includes($(card).data('author')) &&
        language.includes($(card).data('language'))
      ) {
        $filteredCards.push($(card))
      }
    })
    return $filteredCards
  }
  handleCardLoading() {
    const $cardsToLoad = this.filterCards()
    const numberToLoad = this.setsLoaded * this.setLength

    //Empty grid and append the right amount of topics to show
    this.$grid.empty()
    for (let i = 0; i < numberToLoad; i++) {
      if ($cardsToLoad[i]) this.$grid.append($cardsToLoad[i])
    }

    // If there aren't more cards to show, hide the Load More button
    $cardsToLoad.length >= numberToLoad ? this.$loadMore.show() : this.$loadMore.hide()

    //Update the count values
    this.updateCountValues()
  }
  organizeTopicSets() {
    //Build array of every category and create a unique set
    const topicNameDump = []
    const authorNameDump = []
    const languageNameDump = []

    this.$topicFilter.find($('[data-filter]')).each((i, v) => {
      topicNameDump.push($(v).data('filter'))
    })
    this.$cards.each((i, v) => authorNameDump.push($(v).data('author')))
    this.$cards.each((i, v) => languageNameDump.push($(v).data('language')))
    const uniqueTopics = [...new Set(topicNameDump)]
    const uniqueAuthors = [...new Set(authorNameDump)]
    const uniqueLanguage = [...new Set(languageNameDump)]

    this.masterFilter = { topic: uniqueTopics, author: uniqueAuthors, language: uniqueLanguage }
    this.activeFilterSet = { topic: uniqueTopics, author: uniqueAuthors, language: uniqueLanguage }

    //Build categorized object of topics keys, each with an array of their corresponding cards
    uniqueAuthors.forEach(v => this.cardSets[v] = [])
    uniqueLanguage.forEach(v => this.cardSets[v] = [])
    this.$cards.each((i, v) => {
      const author = $(v).data('author')
      const language = $(v).data('language')
      this.cardSets[language].push($(v))
      this.cardSets[author].push($(v))

      if ($(v).data('topic') != '') {
        const cardTopics = $(v).data('topic').split(',')
        for (let index = 0; index < cardTopics.length; index++) {
          const topicString = cardTopics[index]
          if (this.cardSets[topicString] == undefined) {
            this.cardSets[topicString] = []
          }
          this.cardSets[topicString].push($(v))
        }
      } else {
        if (this.cardSets['All'] == undefined) {
          this.cardSets['All'] = []
        }
        this.cardSets['All'].push($(v))
      }
    })
  }
  updateCountValues() {
    const visible = this.$grid.find('.card').length
    const total = this.activeFilter === 'All' ?
      this.$cards.length :
      this.cardSets[this.activeFilter].length

    this.$count.find('span').eq(0).text(visible)
    this.$count.find('span').eq(1).text(total)
  }

  updateQuery(topic, topicVal, author, authorVal, language, languageVal) {
    this.query[topic] = topicVal
    this.query[author] = authorVal
    this.query[language] = languageVal
    const query = queryString.stringify(this.query)
    let unclosedURL = window.location.href.split('blog/')[0]
    let newURL = `${unclosedURL}blog?${query}`
    if (window.location.href.includes('blog/')) {
      window.history.replaceState({}, document.title, newURL)
    } else {
      window.history.replaceState({}, document.title, `blog?${query}`)
    }
  }
}
